export default {
  welcomealert: '第一次拜访新 HKLII ？',
  rourlink: '查看首次使用说明',
  title: '新 HKLII 網站導覽',
  step1: '新版面',
  step2: '搜寻任何文件',
  step3: '进阶搜寻',
  step4: '使用 Noteup',
  step5: '快速浏览法例',
  title1: '以功能划分的版面配置',
  title2: '如何有效地在 HKLII 上搜寻',
  title3: '利用「进阶搜索」查询字段',
  title4: '使用 Noteup 功能寻找引用案例',
  title5: '使用法例导览迅速阅读条文',
  title6: '介绍完毕',
  desc1: [
    '<b>左侧边栏</b>主要展示相关的工具和资料，而与当前页面有关的<b>连结将位于右</b>。',
    '于手机浏览时，网站的结构将调整至上至下排列。',
    '你可以使用视窗右下角的方向按直达钮页面顶端或底部。'
  ],
  desc2: [
    '你可以在此输入关键字搜寻{0} HKLII 内的资料。你能在此使用{1}来有效掌握你的搜寻范围。',
    '网站顶部的搜寻栏与首页的搜寻栏有同样的功能，让你能在任何页面作资料库搜寻。'
  ],
  desc3: [
    '“进阶搜索”能够在<b>指定范畴使用关键词</b>搜索，从而收窄结果数量。',
    '运算子暂时未能在本頁使用。'
  ],
  desc4: [
    '在当前文件使用 <b>Noteup</b> 功能以便<b>快捷查看引用</b>或提及此文件的其他文件。'
  ],
  desc5: [
    '按 <b>“一页显示所有内容”</b> 以完整显示法例内容。按 <b>“目录”</b> 前往该法例的索引。',
    '使用 <b>“往前/往后箭头”</b> 往返前后法例条文。',
    '你可以使用 <b>“相关条例（附属法例）”</b> 快速前往相关法例。'
  ],
  desc6: [
    '本介绍告一段落。若有其他疑问或意见请{email}递交。',
    'HKLII感谢你的到访，希望阁下能抽空为我们{rating}，让HKLII更为你所用。'
  ],
  rating: '评分',
  email: '到此电邮',
  any_content: '任何',
  operators: '运算子',
  videoerror: '请使用 HTML 5 的浏览器观看此说明。',
}